module.exports = __webpack_public_path__ + "img/savedSuccessfully.c105bbfe.png";